'use strict';

const Game = require('../modules/Game.class');
const game = new Game();

const startButton = document.querySelector('.button.start');
const scoreElement = document.querySelector('.game-score');
const messageWin = document.querySelector('.message-win');
const messageLose = document.querySelector('.message-lose');
const messageStart = document.querySelector('.message-start');
const tileContainer = document.querySelector('.tile-container');

const tilesMap = new Map();

function getTilePosition(x, y) {
  return {
    top: `${10 + y * 110}px`,
    left: `${10 + x * 110}px`,
  };
}

function createTileElement(tile) {
  const el = document.createElement('div');

  el.classList.add('tile');
  el.classList.add(`tile--${tile.value}`);
  el.textContent = tile.value;

  const pos = getTilePosition(tile.position.x, tile.position.y);

  el.style.top = pos.top;
  el.style.left = pos.left;

  return el;
}

function renderBoard(state) {
  scoreElement.textContent = state.score;

  messageStart.classList.add('hidden');

  if (state.status === 'won') {
    messageWin.classList.remove('hidden');
  }

  if (state.status === 'lost') {
    messageLose.classList.remove('hidden');
  }

  const activeIds = new Set();

  state.tiles.forEach((tile) => {
    activeIds.add(tile.id);

    if (tile.mergedFrom) {
      tile.mergedFrom.forEach((parent) => {
        if (tilesMap.has(parent.id)) {
          const parentEl = tilesMap.get(parent.id);

          tilesMap.delete(parent.id);

          const pos = getTilePosition(tile.position.x, tile.position.y);

          parentEl.style.top = pos.top;
          parentEl.style.left = pos.left;
          parentEl.style.zIndex = '10';

          setTimeout(() => {
            parentEl.remove();
          }, 200);
        }
      });
    }

    let el = tilesMap.get(tile.id);
    const pos = getTilePosition(tile.position.x, tile.position.y);

    if (!el) {
      el = createTileElement(tile);
      tileContainer.appendChild(el);
      tilesMap.set(tile.id, el);

      if (tile.mergedFrom) {
        el.classList.add('tile-merged');
      } else {
        el.classList.add('tile-new');
      }
    } else {
      el.style.top = pos.top;
      el.style.left = pos.left;

      if (el.textContent !== tile.value) {
        el.textContent = tile.value;
        el.className = `tile tile--${tile.value}`;
        el.classList.add('tile-merged');
      }
    }
  });

  const idsToRemove = [];

  tilesMap.forEach((_, id) => {
    if (!activeIds.has(id)) {
      idsToRemove.push(id);
    }
  });

  idsToRemove.forEach((id) => {
    tilesMap.get(id).remove();
    tilesMap.delete(id);
  });
}

startButton.addEventListener('click', () => {
  messageLose.classList.add('hidden');
  messageWin.classList.add('hidden');

  tileContainer.innerHTML = '';
  tilesMap.clear();

  game.restart();
  startButton.textContent = 'Restart';
  startButton.classList.remove('start');
  startButton.classList.add('restart');
  renderBoard(game.getState());
});

document.addEventListener('keydown', (e) => {
  if (game.getStatus() !== 'playing') {
    return;
  }

  switch (e.key) {
    case 'ArrowLeft':
      game.moveLeft();
      break;
    case 'ArrowRight':
      game.moveRight();
      break;
    case 'ArrowUp':
      game.moveUp();
      break;
    case 'ArrowDown':
      game.moveDown();
      break;
    default:
      return;
  }

  renderBoard(game.getState());
});
